import React from "react";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { useFormik } from "formik";
import { requestsApi } from "../../../api/api";
import CancelIcon from "@mui/icons-material/Cancel";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import { REQUEST_STATUS } from "../../../constants/constants";

export const PilotHistoryEarlierToolbar = ({ setEarlier, selectedUser, search, setSearch, setIsLoading }) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      search: "",
    },
    onSubmit: (fields) => {
      setIsLoading(true);
      setSearch(fields.search);
      requestsApi
        .getByUser(selectedUser, REQUEST_STATUS.EARLIER, fields.search)
        .then((res) => {
          setIsLoading(false);
          setEarlier(res.data);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    },
  });

  return (
    <form className="table-toolbar" onSubmit={formik.handleSubmit}>
      <div>
        {search && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
            {t("search_results")} "{search}"{" "}
            <IconButton
              aria-label="upload picture"
              component="span"
              onClick={() => {
                requestsApi
                  .getByUser(selectedUser, REQUEST_STATUS.EARLIER)
                  .then((res) => {
                    setEarlier(res.data);
                    setSearch("");
                  })
                  .catch((err) => {});
              }}
            >
              <CancelIcon />
            </IconButton>
          </div>
        )}
      </div>
      <TextField
        sx={{ width: window.innerWidth > 450 ? "40%" : "100%", marginBottom: 1, marginTop: 1 }}
        variant="outlined"
        size="small"
        id="search"
        name="search"
        value={formik.values.search}
        onChange={formik.handleChange}
        placeholder={t("search")}
        InputProps={{
          type: "search",
          startAdornment: <SearchIcon fontSize="medium" />,
        }}
      />
    </form>
  );
};
